// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3GSr5","gfeWrapper":"CalendarEvent_gfeWrapper__2h_9k"};